"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullUserName = void 0;
const getFullUserName = ({ firstName, lastName, type = 'long' }) => {
    if (firstName && lastName) {
        const surname = type === 'short' ? `${lastName[0]}.` : lastName;
        return `${firstName} ${surname}`;
    }
    if (firstName)
        return firstName;
    if (lastName)
        return lastName;
    return '';
};
exports.getFullUserName = getFullUserName;
